//@flow
import { graphql } from 'react-relay';
import { generateMutation } from './generateMutation';

export type FirmPortfolioMutationArgs = {
    firmId: string,
    portfolioId: string,
    onCompleted?: Function,
    onError?: Function,
};

const mutation = graphql`
    mutation firmPortfolioMutation($input: FirmInteriorPortfolioMutationInput!) {
        firmInteriorPortfolioMutation(input: $input) {
            tradeFirm {
                serviceId
            }
        }
    }
`;

export const firmPortfolio = generateMutation(mutation);
